"use client";
import {proxy} from "valtio";

import type {IValtioModel} from "@/shared/models/base-model.interface";

import type {CommunityCardData} from "./communities-archive.controller";

export interface CommunitiesModelConfig {
    communities: Array<CommunityCardData>;
}

class CommunitiesModelClass implements IValtioModel {
    communities: Array<CommunityCardData>;
    visibleCount: number;
    itemsPerPage: number;

    constructor(config: CommunitiesModelConfig) {
        this.communities = config.communities;
        this.itemsPerPage = 20; // Default: 5 rows × 4 columns
        this.visibleCount = this.itemsPerPage;
    }

    /**
     * Visible communities (limited by visibleCount)
     */
    get visibleCommunities(): Array<CommunityCardData> {
        return this.communities.slice(0, this.visibleCount);
    }

    /**
     * Show "View More" button when there are more items to show
     */
    get showButton(): boolean {
        return this.visibleCount < this.communities.length;
    }

    /**
     * Set items per page (for responsive breakpoints: 5 rows × columns)
     */
    setItemsPerPage(count: number): void {
        const wasAtInitial = this.visibleCount === this.itemsPerPage;
        this.itemsPerPage = count;
        if (wasAtInitial) {
            this.visibleCount = count;
        }
    }

    /**
     * Load more - show next batch from local array
     */
    loadMore(): void {
        this.visibleCount = Math.min(this.visibleCount + this.itemsPerPage, this.communities.length);
    }

    init(): void {
        // Data already loaded on server
    }
}

export type CommunitiesModelInstance = InstanceType<typeof CommunitiesModelClass>;

export function CommunitiesModel(config: CommunitiesModelConfig): CommunitiesModelInstance {
    return proxy(new CommunitiesModelClass(config));
}
